module.exports = __webpack_public_path__ + "img/denmark-respiratory-diseases-female.97d7b7d0.png";